import React, { memo } from 'react';

/**
 * Placeholder visual para Command Palette (CTRL+K) — sprint futuro.
 */
const CommandPalettePlaceholder = memo(function CommandPalettePlaceholder({ onClick, className = '' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`e0e3-command-trigger group flex h-9 w-full max-w-md items-center gap-2 rounded-lg border border-white/[0.08] bg-white/[0.04] px-3 text-left text-sm text-e0e3-muted transition duration-150 hover:border-e0e3-accent/30 hover:bg-white/[0.06] ${className}`}
      aria-label="Buscar o ir a cualquier parte (próximamente)"
    >
      <span className="text-e0e3-muted/70">⌘</span>
      <span className="flex-1 truncate">Buscar o ir a cualquier parte…</span>
      <kbd className="hidden rounded border border-white/10 bg-black/30 px-1.5 py-0.5 text-[10px] font-medium text-e0e3-muted sm:inline">K</kbd>
    </button>
  );
});

export default CommandPalettePlaceholder;
